import { render, staticRenderFns } from "./MessageItemTimeline.vue?vue&type=template&id=1833fb52&scoped=true"
import script from "./MessageItemTimeline.vue?vue&type=script&lang=js"
export * from "./MessageItemTimeline.vue?vue&type=script&lang=js"
import style0 from "./MessageItemTimeline.vue?vue&type=style&index=0&id=1833fb52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1833fb52",
  null
  
)

export default component.exports